import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BookingService } from '../../core/api/booking.service';
import { DashboardStats } from '../../core/models/booking.model';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, RouterModule, MatCardModule, MatIconModule, MatButtonModule, MatChipsModule, MatProgressSpinnerModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent implements OnInit {
  loading = true;
  newBookings = 0;
  confirmedBookings = 0;
  issuedRentals = 0;
  freeCars = 0;

  constructor(private bookingService: BookingService) {}

  ngOnInit(): void {
    this.loadData();
  }

  private loadData(): void {
    this.loading = true;
    this.bookingService.getDashboardStats().subscribe({
      next: (stats: DashboardStats) => {
        this.newBookings = stats.new_bookings;
        this.confirmedBookings = stats.confirmed_bookings;
        this.issuedRentals = stats.issued_rentals;
        this.freeCars = stats.free_cars;
        this.loading = false;
      },
      error: () => { this.loading = false; },
    });
  }
}
